import React, { useState } from 'react';

import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import { FaChevronLeft } from 'react-icons/fa';

import { useMediaQuery } from 'react-responsive';
import Arrow from '..';

const ArrowLeft: React.FC = () => {
  const mobileOrTablet = useMediaQuery({ query: '(max-width: 1224px)' });

  const {
    isFirstItemVisible,
    scrollPrev,
    visibleItemsWithoutSeparators,
    initComplete,
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = useState(
    !initComplete || (initComplete && isFirstItemVisible),
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollPrev()}>
      <FaChevronLeft size={mobileOrTablet ? 20 : 40} />
    </Arrow>
  );
};

export default ArrowLeft;
